module.exports = __webpack_public_path__ + "static/img/GettyImages-623104412.16d976a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/GettyImages-623104412.jpg
// module id = SPyI
// module chunks = 0